// Basic colors
const BASIC_COLORS = {
  WHITE: { value: 'white', translation: 'white', hex: '#FFFFFF' },
  SOFT_WHITES: { value: 'soft whites', translation: 'softWhites', hex: '#F5F5F5' },
  BLACK: { value: 'black', translation: 'black', hex: '#000000' },
  BLUE: { value: 'blue', translation: 'blue', hex: '#0000FF' },
  RED: { value: 'red', translation: 'red', hex: '#FF0000' },
  GREEN: { value: 'green', translation: 'green', hex: '#00FF00' },
  YELLOW: { value: 'yellow', translation: 'yellow', hex: '#FFFF00' },
  GRAY: { value: 'grey', translation: 'grey', hex: '#808080' },
  BROWN: { value: 'brown', translation: 'brown', hex: '#A52A2A' },
  ORANGE: { value: 'orange', translation: 'orange', hex: '#FFA500' },
  PURPLE: { value: 'purple', translation: 'purple', hex: '#800080' },
  PINK: { value: 'pink', translation: 'pink', hex: '#FFC0CB' },
  BEIGE: { value: 'beige', translation: 'beige', hex: '#F5F5DC' },
  GOLD: { value: 'gold', translation: 'gold', hex: '#FFD700' },
  SILVER: { value: 'silver', translation: 'silver', hex: '#C0C0C0' },
  BRONZE: { value: 'bronze', translation: 'bronze', hex: '#CD7F32' },
} as const;

// Living Room specific colors
const LIVING_ROOM_COLORS = {
  IVORY: { value: 'ivory', translation: 'ivory', hex: '#FFFFF0' },
  MINK: { value: 'mink', translation: 'mink', hex: '#8B7355' },
  EARTH_TONES: { value: 'earth tones', translation: 'earthTones', hex: '#8B4513' },
  OLIVE: { value: 'olive', translation: 'olive', hex: '#808000' },
  TAN: { value: 'tan', translation: 'tan', hex: '#D2B48C' },
  WARM_SHADES: { value: 'warm shades', translation: 'warmShades', hex: '#DEB887' },
  RICH_BLUES: { value: 'rich blues', translation: 'richBlues', hex: '#191970' },
  DEEP_GREEN: { value: 'deep green', translation: 'deepGreen', hex: '#006400' },
  BURGUNDY: { value: 'burgundy', translation: 'burgundy', hex: '#800020' },
  GREY: { value: 'grey', translation: 'grey', hex: '#808080' },
  PASTEL_TURQUOISE: { value: 'pastel turquoise', translation: 'pastelTurquoise', hex: '#A0E6E6' },
  TERRACOTTA: { value: 'terracotta', translation: 'terracotta', hex: '#E2725B' },
  PETROL: { value: 'petrol', translation: 'petrol', hex: '#006A71' },
  CORAL_RED: { value: 'coral red', translation: 'coralRed', hex: '#FF4040' },
  MINT_GREEN: { value: 'mint green', translation: 'mintGreen', hex: '#AAF0D1' },
  ANTHRAZIT_FURNITURE: {
    value: 'anthrazit furniture',
    translation: 'anthrazitFurniture',
    hex: '#383E42',
  },
  LIGHT_PEACH: { value: 'light peach', translation: 'lightPeach', hex: '#FFDAB9' },
  ANTHRAZIT_FLOOR: { value: 'anthrazit floor', translation: 'anthrazitFloor', hex: '#383E42' },
} as const;

// Bedroom specific colors
const BEDROOM_COLORS = {
  TAUPE: { value: 'taupe', translation: 'taupe', hex: '#483C32' },
  PASTEL_BLUE: { value: 'pastel blue', translation: 'pastelBlue', hex: '#B0E0E6' },
  SAGE_GREEN: { value: 'sage green', translation: 'sageGreen', hex: '#9CAF88' },
  BLUSH_PINK: { value: 'blush pink', translation: 'blushPink', hex: '#FFB6C1' },
  WARM_GREY: { value: 'warm grey', translation: 'warmGrey', hex: '#A9A9A9' },
  MUTED_LAVENDER: { value: 'muted lavender', translation: 'mutedLavender', hex: '#E6E6FA' },
  CHARCOAL: { value: 'charcoal', translation: 'charcoal', hex: '#36454F' },
  NAVY: { value: 'navy', translation: 'navy', hex: '#000080' },
} as const;

// Kitchen specific colors
const KITCHEN_COLORS = {
  STONE: { value: 'stone', translation: 'stone', hex: '#8B8B8B' },
  EMERALD_GREEN: { value: 'emerald green', translation: 'emeraldGreen', hex: '#50C878' },
  NAVY_BLUE: { value: 'navy blue', translation: 'navyBlue', hex: '#191970' },
  BRICK_RED: { value: 'brick red', translation: 'brickRed', hex: '#B22222' },
  STEEL: { value: 'steel', translation: 'steel', hex: '#4682B4' },
  SANDY_BEIGE: { value: 'sandy beige', translation: 'sandyBeige', hex: '#F5F5DC' },
} as const;

// Dining Room specific colors
const DINING_ROOM_COLORS = {
  DARK_BROWN: { value: 'dark brown', translation: 'darkBrown', hex: '#654321' },
  RICH_BURGUNDY: { value: 'rich burgundy', translation: 'richBurgundy', hex: '#8B0000' },
  OLIVE_GREEN: { value: 'olive green', translation: 'oliveGreen', hex: '#6B8E23' },
  MUTED_YELLOW: { value: 'muted yellow', translation: 'mutedYellow', hex: '#F0E68C' },
  WINE_RED: { value: 'wine red', translation: 'wineRed', hex: '#722F37' },
} as const;

// Kitchen Living Combo specific colors
const KITCHEN_LIVING_COMBO_COLORS = {
  SOFT_GREEN: { value: 'soft green', translation: 'softGreen', hex: '#90EE90' },
  SOFT_GREY: { value: 'soft grey', translation: 'softGrey', hex: '#D3D3D3' },
  PASTEL_ACCENTS: { value: 'pastel accents', translation: 'pastelAccents', hex: '#FFE4E1' },
} as const;

// Bathroom specific colors
const BATHROOM_COLORS = {
  AQUA: { value: 'aqua', translation: 'aqua', hex: '#00FFFF' },
  PEBBLE_TAUPE: { value: 'pebble taupe', translation: 'pebbleTaupe', hex: '#8B7355' },
  BLUSH: { value: 'blush', translation: 'blush', hex: '#FFB6C1' },
  MINT: { value: 'mint', translation: 'mint', hex: '#98FF98' },
} as const;

// General colors (used across multiple room types)
const GENERAL_COLORS = {
  LIGHT_GREY: { value: 'light grey', translation: 'lightGrey', hex: '#808080' },
  LIGHT_WOOD: { value: 'light wood', translation: 'lightWood', hex: '#E6D3B3' },
  NATURAL_BROWN: { value: 'natural brown', translation: 'naturalBrown', hex: '#8B5A2B' },
  WALNUT: { value: 'walnut', translation: 'walnut', hex: '#5C4033' },
  WALNUT_BROWN: { value: 'walnut brown', translation: 'walnutBrown', hex: '#654321' },
  NATURAL_WOOD: { value: 'natural wood', translation: 'naturalWood', hex: '#DEB887' },
  LIGHT_BLUE: { value: 'light blue', translation: 'lightBlue', hex: '#ADD8E6' },
  DARK_GREEN: { value: 'dark green', translation: 'darkGreen', hex: '#013220' },
  DEEP_BROWN: { value: 'deep brown', translation: 'deepBrown', hex: '#4B3621' },
  GLASS_CLEAR: { value: 'glass clear', translation: 'glassClear', hex: '#E6F0F8' },
  BRIGHT_BLUE: { value: 'bright blue', translation: 'brightBlue', hex: '#0096FF' },
  ECO_GREEN: { value: 'eco green', translation: 'ecoGreen', hex: '#3CB371' },
  SLATE: { value: 'slate', translation: 'slate', hex: '#708090' },
  PASTEL_PURPLE: { value: 'pastel purple', translation: 'pastelPurple', hex: '#C3B1E1' },
  PINE: { value: 'pine', translation: 'pine', hex: '#01796F' },
  LINEN: { value: 'linen', translation: 'linen', hex: '#FAF0E6' },
  LIGHT_BROWN: { value: 'light brown', translation: 'lightBrown', hex: '#C4A484' },
  MATTE_BLACK: { value: 'matte black', translation: 'matteBlack', hex: '#1C1C1C' },
  WASHED_WOOD: { value: 'washed wood', translation: 'washedWood', hex: '#E5D7B8' },
  CHERRY: { value: 'cherry', translation: 'cherry', hex: '#A31621' },
} as const;

// Combined color options - maintains backward compatibility
export const DESIRED_COLOR_OPTIONS = {
  ...BASIC_COLORS,
  ...LIVING_ROOM_COLORS,
  ...BEDROOM_COLORS,
  ...KITCHEN_COLORS,
  ...DINING_ROOM_COLORS,
  ...KITCHEN_LIVING_COMBO_COLORS,
  ...BATHROOM_COLORS,
  ...GENERAL_COLORS,
} as const;
type DesiredColorOptionKey = keyof typeof DESIRED_COLOR_OPTIONS;
export type TYPE_DESIRED_COLOR_OPTIONS = (typeof DESIRED_COLOR_OPTIONS)[DesiredColorOptionKey];

// Basic materials
const BASIC_MATERIALS = {
  WOOD: { value: 'wood', translation: 'wood', hex: '#8B4513' },
  LEATHER: { value: 'leather', translation: 'leather', hex: '#3B2B20' },
  COPPER: { value: 'copper', translation: 'copper', hex: '#7C4D3A' },
  STEEL: { value: 'steel', translation: 'steel', hex: '#2A3439' },
  GLASS: { value: 'glass', translation: 'glass', hex: '#F5F5F5' },
  MARBLE: { value: 'marble', translation: 'marble', hex: '#FFFFFF' },
  MARBLE_COUNTERTOP: {
    value: 'marble countertop',
    translation: 'marbleCounterTops',
    hex: '#FFFFFF',
  },
  GRANITE: { value: 'granite', translation: 'granite', hex: '#4E5452' },
  CONCRETE: { value: 'concrete', translation: 'concrete', hex: '#D3D3D3' },
  BRICK: { value: 'brick', translation: 'brick', hex: '#B22222' },
  CERAMIC: { value: 'ceramic', translation: 'ceramic', hex: '#0000FF' },
  PORCELAIN: { value: 'porcelain', translation: 'porcelain', hex: '#FAF0E6' },
  BAMBOO: { value: 'bamboo', translation: 'bamboo', hex: '#E4D00A' },
  COTTON: { value: 'cotton', translation: 'cotton', hex: '#F8F8FF' },
  RATTAN: { value: 'rattan', translation: 'rattan', hex: '#D8BFD8' },
} as const;

// Living Room specific materials
const LIVING_ROOM_MATERIALS = {
  OAK_HARDWOOD: { value: 'oak hardwood', translation: 'oakHardwood', hex: '#8B4513' },
  OAK: { value: 'oak', translation: 'oak', hex: '#8B4513' },
  TEAK: { value: 'teak', translation: 'teak', hex: '#B8860B' },
  WHITE_ASH: { value: 'white ash', translation: 'whiteAsh', hex: '#F5F5DC' },
  VENEERED_WOOD: { value: 'veneered wood', translation: 'veneeredWood', hex: '#A0522D' },
  PLUSH_FABRICS: { value: 'plush fabrics', translation: 'plushFabrics', hex: '#DEB887' },
  PLUSH_FABRICS_ACCENTCHAIRS: {
    value: 'plush fabrics accent chairs',
    translation: 'plushFabricsAccentChairs',
    hex: '#DEB887',
  },
  METAL: { value: 'metal', translation: 'metal', hex: '#C0C0C0' },
  DECORATIVE_MELAMINE: {
    value: 'decorative melamine',
    translation: 'decorativeMelamine',
    hex: '#F5F5F5',
  },
  BWP_PLYWOOD: { value: 'bwp plywood', translation: 'bwpPlywood', hex: '#8B4513' },
  PORCELAIN_STONEWARE: {
    value: 'porcelain stoneware',
    translation: 'porcelainStoneware',
    hex: '#FAF0E6',
  },
  LEATHER_COUCH: { value: 'leather couch', translation: 'leatherCouch', hex: '#3B2B20' },
  CHERRY_WOOD: { value: 'cherry wood', translation: 'cherryWood', hex: '#8E3B2E' },
  MAPLE_WOOD: { value: 'maple wood', translation: 'mapleWood', hex: '#C9A368' },
  BEECH_WOOD: { value: 'beech wood', translation: 'beechWood', hex: '#E3C29D' },
  WALNUT_WOOD: { value: 'walnut wood', translation: 'walnutWood', hex: '#654321' },
  COOPER: { value: 'copper', translation: 'copper', hex: '#7C4D3A' },
  BRONZE_MATERIAL: { value: 'bronze', translation: 'bronze', hex: '#CD7F32' },
} as const;

// Bedroom specific materials
const BEDROOM_MATERIALS = {
  FABRIC_UPHOLSTERY: {
    value: 'fabric upholstery',
    translation: 'fabricUpholstery',
    hex: '#DEB887',
  },
  LAMINATE: { value: 'laminate', translation: 'laminate', hex: '#F5F5F5' },
  VENEER: { value: 'veneer', translation: 'veneer', hex: '#A0522D' },
  PLUSH_TEXTILES: { value: 'plush textiles', translation: 'plushTextiles', hex: '#DEB887' },
  LACQUERED_WOOD: { value: 'lacquered wood', translation: 'lacqueredWood', hex: '#8B4513' },
  MDF: { value: 'MDF', translation: 'MDF', hex: '#D3D3D3' },
  LINEN: { value: 'linen', translation: 'linen', hex: '#FAF0E6' },
} as const;

// Kitchen specific materials
const KITCHEN_MATERIALS = {
  STAINLESS_STEEL: { value: 'stainless steel', translation: 'stainlessSteel', hex: '#C0C0C0' },
  QUARTZ: { value: 'quartz', translation: 'quartz', hex: '#F5F5F5' },
} as const;

// Dining Room specific materials
const DINING_ROOM_MATERIALS = {
  LEATHER_CHAIRS: { value: 'leather chairs', translation: 'leatherChairs', hex: '#3B2B20' },
} as const;

// Kitchen Living Combo specific materials
const KITCHEN_LIVING_COMBO_MATERIALS = {
  LEATHER_COUCH_AND_CHAIRS: {
    value: 'leather counch and chairs',
    translation: 'leatherCounchAndChairs',
    hex: '#3B2B20',
  },
  BLACK_METAL_INDUSTRIAL: { value: 'black metal', translation: 'blackMetal', hex: '#1C1C1C' },
} as const;

// Bathroom specific materials
const BATHROOM_MATERIALS = {
  MOSAIC_TILES: { value: 'mosaic tiles', translation: 'mosaicTiles', hex: '#4682B4' },
  FISHBONE_TILES: { value: 'fishbone tiles', translation: 'fishboneTiles', hex: '#696969' },
  MANHATTAN_TILES: { value: 'manhattan tiles', translation: 'manhattanTiles', hex: '#B0B0B0' },
  SQUARE_TILES: { value: 'square tiles', translation: 'squareTiles', hex: '#A9A9A9' },
  BIG_RECTANGLE_TILES: {
    value: 'big rectangle tiles',
    translation: 'bigRectangleTiles',
    hex: '#9E9E9E',
  },
  PARQUET_TILES: { value: 'parquet tiles', translation: 'parquetTiles', hex: '#C2A072' },
  PATCHWORK_TILES: { value: 'patchwork tiles', translation: 'patchworkTiles', hex: '#C0C0C0' },
} as const;

// General materials (used across multiple room types)
const GENERAL_MATERIALS = {
  SOLID_WOOD: { value: 'solid wood', translation: 'solidWood', hex: '#8B4513' },
  HDPE: { value: 'HDPE', translation: 'HDPE', hex: '#F5F5F5' },
  ENGINEERED_WOOD: { value: 'engineered wood', translation: 'engineeredWood', hex: '#A0522D' },
  STONE: { value: 'stone', translation: 'stone', hex: '#8B8B8B' },
  ACRYLIC: { value: 'acrylic', translation: 'acrylic', hex: '#F0F8FF' },
  RECYCLED_PLASTICS: {
    value: 'recycled plastics',
    translation: 'recycledPlastics',
    hex: '#2E8B57',
  },
  FABRIC: { value: 'fabric', translation: 'fabric', hex: '#DEB887' },
  DENIM: { value: 'denim', translation: 'denim', hex: '#4682B4' },
  MELAMINE: { value: 'melamine', translation: 'melamine', hex: '#F5F5F5' },
  RECYCLED_PLASTIC: { value: 'recycled plastic', translation: 'recycledPlastic', hex: '#2E8B57' },
  SAFE_PAINTS: { value: 'safe paints', translation: 'safePaints', hex: '#FFD700' },
  TEMPERED_GLASS: { value: 'tempered glass', translation: 'temperedGlass', hex: '#F5F5F5' },
  MARINE_GRADE_PLYWOOD: {
    value: 'marine-grade plywood',
    translation: 'marineGradePlywood',
    hex: '#8B4513',
  },
  LACQUERED_FINISHES: {
    value: 'lacquered finishes',
    translation: 'lacqueredFinishes',
    hex: '#8B4513',
  },
} as const;

// Combined material options - maintains backward compatibility
export const MATERIAL_OPTIONS = {
  ...BASIC_MATERIALS,
  ...LIVING_ROOM_MATERIALS,
  ...BEDROOM_MATERIALS,
  ...KITCHEN_MATERIALS,
  ...DINING_ROOM_MATERIALS,
  ...KITCHEN_LIVING_COMBO_MATERIALS,
  ...BATHROOM_MATERIALS,
  ...GENERAL_MATERIALS,
} as const;
type MaterialOptionKey = keyof typeof MATERIAL_OPTIONS;
export type TYPE_MATERIAL_OPTIONS = (typeof MATERIAL_OPTIONS)[MaterialOptionKey];
